export default class FriendInfo{
    title = '';
    userInfos = [];

    updateUserInfo(userInfo){
        var existUserInfo = this.userInfos.find(existUserInfo => existUserInfo.uid == userInfo.uid)
        if(existUserInfo){
            existUserInfo = userInfo;
        } else {
            this.userInfos.push(userInfo)
        }
    }

    static createFriendInfo(userInfo){
        var friendInfo = new FriendInfo();
        friendInfo.title = userInfo.firstLetter
        friendInfo.userInfos.push(userInfo)
        return friendInfo
    }
}


// WEBPACK FOOTER //
// ./src/fscommon/websocket/model/friendInfo.js